type Maybe<T> = T | null

export function isDefined<T>(x: Maybe<T>): x is T {
  return x !== undefined && x !== null
}

export function getOrElse<T>(x: Maybe<T>, defaultValue: T): T {
  return isDefined(x) ? x : defaultValue
}

//
// Used to put stuff in input text fields. Always returns string
//
export function getOrElseEmptyString<T>(x: Maybe<T>): string {
  return isDefined(x) ? `${x}` : ''
}
